// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SplitCellsOutlinedSvg from "@fishx/icons-svg/es/asn/SplitCellsOutlined";
import FishxIcon from '../components/FishxIcon';

var SplitCellsOutlined = function SplitCellsOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SplitCellsOutlinedSvg
  }));
};

SplitCellsOutlined.displayName = 'SplitCellsOutlined';
export default React.forwardRef(SplitCellsOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SplitCellsOutlined.js
// module id = 4184
// module chunks = 0